import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import IfengComment from '@ifeng/three_terminal/es/pc/comment/comment';
import errorBoundary from '@ifeng/errorBoundary';
import Chip from 'Chip';

const Comment = ({ content, commentTitleImage }) => {
    const commentDomain = typeof window === 'object' && window.allData?.__cd__ ? window.allData.__cd__ : 'c01049em.ifeng.com';
    
    return (
        <div className={styles.comment}>
            <Chip id="260728" title="评论专区标题图" groupName="中国力量" type="struct">
                <div className={styles.commentTitle}>
                    <img src={commentTitleImage} />
                </div>
            </Chip>
            <div className={styles.commentBox}>
                <IfengComment
                    articleInfo={{
                        noAd: true,
                        // 文章单页的页面地址 commentUrl
                        docUrl: `ucms_${content.base62Id}`,
                        // 文章的标题
                        docTitle: content.title,
                        // 文章评论的skey，这个是在后端生成好后给到前端的，个性化页面没有skey的话，可以为空
                        skey: content.skey,
                        // 兼容以后的专题评论
                        speUrl: '',
                        // 文章pc的页面地址
                        pcUrl: '',
                        // 获取评论内容接口
                        cmtNumUrl: `https://${ commentDomain }/get.php`,
                        // 评论内容字数长度
                        cmtLength: 1000,
                        // 提交评论内容接口
                        cmtPostUrl: `https://${ commentDomain }/post.php`,
                        // 最热评论数量
                        hotLimit: 2,
                        // 推荐评论接口
                        cmtVoteUrl: `https://${ commentDomain }/vote.php`,
                        // 现实回复的楼层
                        replyLimit: 3,
                        // 举报提交接口
                        jubUrl: `https://${ commentDomain }/report`,
                        // 举报次数，便于每次回调函数名不同
                        jubNum: 0,
                        // 是否是评论详情页面
                        isComment: false,
                        // docUrl: "ucms_86YOkEdIiC1"
                    }}
                />
            </div>
        </div>
    );
};

Comment.propTypes = {
    content: PropTypes.object,
    commentTitleImage: PropTypes.string,
};

export default errorBoundary(Comment);
